import { area, curveMonotoneX, curveStepAfter } from 'd3-shape';
import { memo } from 'react';
import { useEventContext, useOptionsContext } from '../../context';

const Area = memo(
  ({
    data,
    keyX,
    keyY0,
    keyY1,
    scaleX,
    scaleY,
    curve = curveMonotoneX,
    color,
    onAreaClick,
    detailsKey,
    details,
    ...props
  }: any) => {
    const { hoveredTick, handleMouseEnter, handleMouseLeave, handleClick } = useEventContext();
    const { chartId } = useOptionsContext();

    const d = area()
      .curve(curve)
      .defined(
        d =>
          !(
            (keyX && Number.isNaN(d[keyX])) ||
            Number.isNaN(d[keyY0] || 0) ||
            Number.isNaN(d[keyY1])
          ),
      )
      .x((d, i) => scaleX(keyX ? d[keyX] : i))
      .y0(d => scaleY(d[keyY0] || 0))
      .y1(d => scaleY(d[keyY1]))(data);

    const id = `${chartId}-gradient-${color}`;
    const safeGetData = (tick: number, key: string) => {
      if (data[tick]) {
        return data[tick][key];
      }
      return undefined;
    };

    return (
      <>
        <defs>
          <linearGradient id={id} x1="0" y1="0" x2="0" y2="1">
            <stop offset="5%" stopColor={color} stopOpacity={0.5} />
            <stop offset="95%" stopColor={color} stopOpacity={0.05} />
          </linearGradient>
        </defs>
        <path
          d={d}
          stroke="none"
          onMouseEnter={event => handleMouseEnter(keyY1, event)}
          onMouseLeave={event => handleMouseLeave(keyY1, event)}
          onClick={event => {
            if (onAreaClick && data[hoveredTick]) {
              onAreaClick({
                details: safeGetData(hoveredTick, detailsKey),
                dataIndex: hoveredTick,
                dataPeriod: detailsKey,
              });
            }
            return handleClick(keyY1, event);
          }}
          fill={`url(#${id})`}
          {...props}
        />
      </>
    );
  },
);

export const AreaStepped = (props: any) => <Area {...props} curve={curveStepAfter} />;

export default Area;
